var _path, _ellipse, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChurch7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1920,
    height: 1080,
    viewBox: "0 0 1920 1080",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M538 396L538 424",
    stroke: "#F2DCCE",
    strokeWidth: 2
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 538.5,
    cy: 391.333,
    rx: 16.5,
    ry: 16.3333,
    fill: "#F2DCCE"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M533.987 391.19C533.987 387.283 537.288 384.117 541.358 384.117C541.943 384.117 542.511 384.184 543.056 384.308C541.742 383.48 540.187 383 538.519 383C533.814 383 530 386.806 530 391.5C530 396.194 533.814 400 538.519 400C540.814 400 542.895 399.093 544.427 397.62C543.492 398.032 542.454 398.263 541.358 398.263C537.288 398.263 533.987 395.096 533.987 391.19Z",
    fill: "#CC7D61"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M547.402 390.6L547.37 388.146L545.535 389.719L543.304 389.056L544.112 391.337L542.765 393.381L545.1 393.218L546.499 395.144L547.133 392.763L549.345 391.909L547.402 390.6Z",
    fill: "#CC7D61"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChurch7);
export default __webpack_public_path__ + "static/media/church_7.c33745ae599fd1c5c1c4b9ae3b44c589.svg";
export { ForwardRef as ReactComponent };